import { createSlice } from '@reduxjs/toolkit';
// import { database } from 'faker/locale/en_AU';
// utils
import axios from '../../utils/axios';
import axiosCustomization from '../../utils/axiosCustomization';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  clients: null,
  cadences: null,
  createdClient: null,
  detailInfo: null,
  updateClient: null,
  scheduledPauses: null,
  clientEndpoints: null,
  createEndpoints: null,
  updateEndpoints: null,
  duplicateEndpoints: null,
  endpointMap: null,
  updateMap: null,
  clientTokens: null,
  createTokens: null,
  deleteTokens: null,
  updateTokens: null,
  clientIntegrationsEx: null,
  createIntegrationsEx: null,
  deleteIntegrationsEx: null,
  updateIntegrationsEx: null,
  columns: null,
  data: null,
  leadSearchData: null,
  saveLeadData: null,
  fieldMappings:[],
  fieldMappingsAll:[],
  inboundProducts: [],
  customizationLibraries: [],
  postbackCustomizationLibraries: [],
  lqClientId: null,
  authenticationTypes:[],
  sendTypes:[],
  endPointTypes: [],
  lqclientproductlist:[],
  lqsaidlist:[],
  cadencenames:[],
  clientExceptions:[],
  createCadence: null,
  duplicateCadence: null,
  updateCadence: null,
  deleteCadences: null,
  createBlackout: null,
  duplicateBlackout: null,
  updateBlackout: null,
  deleteBlackout: null,
  createPhoneConf: null,
  updatePhoneConf: null,
  createSMSConf: null,
  updateSMSConf: null,
  createEmailConf: null,
  updateEmailConf: null,
  createTouchPoint: null,
  archiveCadences: null,
  createFolloup: null,
  createEndCadence: null,
  updateFolloup: null,
  deleteFolloup: null,
  deleteEndCadence: null,
  updateEndCadence: null,
  endMap : null,
  disposition: null,
  touchPoint: null,
  inbountTouch: null,
  leadData: null,
  options: null,
  bookings: [],
  endCadenceType: null
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    formatError(state, action) {
      state.error = false;
    },

    saveColumn(state, action) {
      state.isLoading = false;
      state.columns = action.payload;
    },

    saveData(state, action) {
        state.isLoading = false;
        state.data = action.payload;
    },

    saveLeadData(state, action) {
      state.isLoading = false;
      state.saveLeadData = action.payload;
    },

    getClient(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    getCadence(state, action) {
      state.isLoading = false;
      state.cadences = action.payload;
    },

    getLeadData(state, action) {
      state.isLoading = false;
      state.leadSearchData = action.payload;
    },

    //GET BOOKING LIST
    getBookingList(state, action) {
      state.isLoading = false;
      state.bookings = action.payload;
    },

    // GET PROFILE
    getClientIntegration(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },

    // GET PROFILE
    getExceptionsByClientID(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },
    // GET PROFILE
    clearExceptionsByClientId(state, action) {
      state.isLoading = false;
      state.clientExceptions = action.payload;
    },

    // GET PROFILE
    getFieldMappings(state, action) {
      state.isLoading = false;
      state.fieldMappings = action.payload;
    },

    getInboundProducts(state, action) {
      if (action?.loadingIndicator) { state.isLoading = false; }
      state.inboundProducts = action.payload.data.inbound_products;
      state.lqClientId = action.payload.data.lq_client_id;
    },
    
    getCustomizationLibraries(state, action) {
      if (action?.loadingIndicator) { state.isLoading = false; }
      state.customizationLibraries = action.payload.data;
    },

    getPostbackCustomizationLibraries(state, action) {
      if (action?.loadingIndicator) { state.isLoading = false; }
      state.postbackCustomizationLibraries = action.payload.data;
    },    

    // GET PROFILE
    getFieldMappingsAll(state, action) {
      state.isLoading = false;
      state.fieldMappingsAll = action.payload;
    },

    getClientPhoneFieldMappings(state, action) {
      state.isLoading = false;
      state.clientPhoneFieldMappings = action.payload;
    },
    getLqClientProductList(state, action) {
      state.isLoading = false;
      state.lqclientproductlist = action.payload;
    },

    getSaidID(state, action) {
      state.isLoading = false;
      state.lqsaidlist = action.payload;
    },

    getCadenceNames(state, action) {
      // state.isLoading = false;
      state.cadencenames = action.payload;
    },

    //CREACT CLIENTINTEGRATION ACCOUNT
    createClientIntegration(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },

    // TODO - finalize
    createClient(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },    

    createClientEndpoints(state, action) {
      state.isLoading = false;
      state.createEndpoints = action.payload;
    },

    createClientCadences(state, action) {
      state.isLoading = false;
      state.createCadence = action.payload;
    },

    createBlackout(state, action) {
      state.isLoading = false;
      state.createBlackout = action.payload;
    },

    createClientTouchPoint(state, action) {
      state.isLoading = false;
      state.createTouchPoint = action.payload;
    },

    createClientFollowUp(state, action) {
      state.isLoading = false;
      state.createFolloup = action.payload;
    },

    updateClientFollowUp(state, action) {
      state.isLoading = false;
      state.updateFolloup = action.payload;
    },
    createClientEndCadnece(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadnece(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },

    deleteClientEndCadence(state, action) {
      state.isLoading = false;
      state.deleteEndCadence = action.payload;
    },
    deleteClientFollowUp(state, action) {
      state.isLoading = false;
      state.deleteFolloup = action.payload;
    },
    
    createClientEndCadence(state, action) {
      state.isLoading = false;
      state.createEndCadence = action.payload;
    },

    updateClientEndCadence(state, action) {
      state.isLoading = false;
      state.updateEndCadence = action.payload;
    },
    
    duplicateClientCadences(state, action) {
      state.isLoading = false;
      state.duplicateCadence = action.payload;
    },

    duplicateBlackout(state, action) {
      state.isLoading = false;
      state.duplicateBlackout = action.payload;
    },

    createdPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.createPhoneConf = action.payload;
    },

    createdEmailConfiguration(state, action) {
      state.isLoading = false;
      state.createEmailConf = action.payload;
    },

    createdSMSConfiguration(state, action) {
      state.isLoading = false;
      state.createSMSConf = action.payload;
    },

    updatedPhoneConfiguration(state, action) {
      state.isLoading = false;
      state.updatePhoneConf = action.payload;
    },
    
    updatedSMSConfiguration(state, action) {
      state.isLoading = false;
      state.updateSMSConf = action.payload;
    },

    updatedEmailConfiguration(state, action) {
      state.isLoading = false;
      state.updateEmailConf = action.payload;
    },

    deleteClientCadences(state, action) {
      state.isLoading = false;
      state.deleteCadences = action.payload;
    },

    deleteBlackout(state, action) {
      state.isLoading = false;
      state.deleteBlackout = action.payload;
    },

    ArchiveClientCadences(state, action) {
      state.isLoading = false;
      state.archiveCadences = action.payload;
    },

    getScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },

    updateScheduledPauses(state, action) {
      state.isLoading = false;
      state.scheduledPauses = action.payload;
    },    
    
    updateClientEndpoints(state, action) {
      state.isLoading = false;
      state.updateEndpoints = action.payload;
    },

    duplicateClientEndpoints(state, action) {
      state.isLoading = false;
      state.duplicateEndpoints = action.payload;
    },    

    updateClientCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateBlackout(state, action) {
      state.isLoading = false;
      state.updateBlackout = action.payload;
    },
    
    startCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    pauseCadences(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientTokens(state, action) {
      state.isLoading = false;
      state.updateTokens = action.payload;
    },

    createClientTokens(state, action) {
      state.isLoading = false;
      state.createTokens = action.payload;
    },

    deleteClientTokens(state, action) {
      state.isLoading = false;
      state.deleteTokens = action.payload;
    },

    updateClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.updateIntegrationsEx = action.payload;
    },

    createClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.createIntegrationsEx = action.payload;
    },

    deleteClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.deleteIntegrationsEx = action.payload;
    },

    getDetailInfo(state, action) {
      // state.isLoading = false;
      state.detailInfo = action.payload;
    },
    
    // TODO - Finalize
    updateClient(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    updateCadence(state, action) {
      state.isLoading = false;
      state.updateCadence = action.payload;
    },

    updateClientIntegration(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    getClientEndpoints (state, action) {
      state.isLoading = false;
      state.clientEndpoints = action.payload;
    },

    getClientTokens (state, action) {
      state.isLoading = false;
      state.clientTokens = action.payload;
    },

    getClientIntegrationsEx (state, action) {
      state.isLoading = false;
      state.clientIntegrationsEx = action.payload;
    },

    getClientIntegrationsBasic (state, action) {
      state.isLoading = false;
      state.clientIntegrationsBasic = action.payload;
    },

    getEndpointMap (state, action) {
      state.isLoading = false;
      state.endpointMap = action.payload;
    },

    getAuthenticationType (state, action) {
      // state.isLoading = false;
      state.authenticationTypes = action.payload;
    },

    getSendType (state, action) {
      state.isLoading = false;
      state.sendTypes = action.payload;
    },

    getEndpointType (state, action) {
      // state.isLoading = false;
      state.endPointTypes = action.payload;
    },

    updateEndpointMap (state, action) {
      state.isLoading = false;
      state.updateMap = action.payload;
    },
    getEndPointMapping (state, action){
      state.isLoading = false;
      state.endMap = action.payload;
    },
    getFinalDisposition (state, action) {
      state.isLoading = false;
      state.disposition = action.payload;
    },
    getTouchPointOutcome (state, action) {
      state.isLoading = false;
      state.touchPoint = action.payload;
    },
    getInboundTouchpoint (state, action) {
      state.isLoading = false;
      state.inbountTouch = action.payload;
    },
    getIncludeLeadData (state, action) {
      state.isLoading = false;
      state.leadData = action.payload;
    },
    getSubAccount (state, action){
      state.isLoading = false;
      state.subAccountData = action.payload;
    },
    getEndCadenceType (state, action){
      state.isLoading = false;
      state.endCadenceType = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

export function saveCSVData(columns, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveColumn(columns));
    dispatch(slice.actions.saveData(data));
  };
}

export function saveLeadData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/savelead', {data: data});
      dispatch(slice.actions.saveLeadData(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function saveLeadDataV1(id,data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      // const response = await axios.post('/api/v1/post/'+id, {data: data});
      const response = await axios.post('/api/v1/bulkleadpost/'+id, {data: data});
      dispatch(slice.actions.endLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.endLoading());
      return []
    }
  };
}
export function formatSaveLeadData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveLeadData(null));
  };
}

// ----------------------------------------------------------------------

export function getEndpointMap(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getmapping', {id: id});
      dispatch(slice.actions.getEndpointMap(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function endpointFieldmappings(id) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/mappings/endpoint/fieldmappings/'+id);
      dispatch(slice.actions.endLoading());
      return response
    } catch (error) {
      throw error
    }
  };
}


// ----------------------------------------------------------------------

export function getAuthenticationType() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/getAuthenticationType');
    //   let tempData = response.data.filter((li, i) => li.id !== 3 && li.id !== 4)
      dispatch(slice.actions.getAuthenticationType(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getSendType() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/getSendType');
      dispatch(slice.actions.getSendType(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEndpointType() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/getEndpointType');
      // dispatch(slice.actions.getEndpointType(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function updateEndpointMap(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/saveFieldmappings', data);
      // dispatch(slice.actions.updateEndpointMap(response.data));
      return response.data;
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return 0;
    }
  };
}

export function deleteEndpointVersion(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/deleteEndpointVersion', data);
      // dispatch(slice.actions.updateEndpointMap(response.data));
      return response.data;
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return 0;
    }
  };
}

export function formatEndpointMap() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateEndpointMap(null));
  };
}

// ----------------------------------------------------------------------


// TODO - finalize
export function getClients() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/clients');
      dispatch(slice.actions.getClient(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadences(isActive = 0, hasActiveLeads = 0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      let params = {};
      if (isActive) {
        params.is_active = 1;
      }
      if (hasActiveLeads) {
        params.has_active_leads = 1;
      }

      const response = await axios.get('/iapi/cadence/management/list', {params: params});
      dispatch(slice.actions.getCadence(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadencesEndpoint(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/cadence_endpoint', {lead_id: id});
      dispatch(slice.actions.getCadence(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function leadSearch(data, isLoading) {
  return async (dispatch) => {
    if(isLoading) {
      dispatch(slice.actions.startLoading());
    }
    try {
      const response = await axios.post('/iapi/cadence/management/leadSearch', data);
      dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadDetails(lead_id, isLoading) {
  return async (dispatch) => {
    if(isLoading) {
      dispatch(slice.actions.startLoading());
    }
    try {
      const response = await axios.get(`/iapi/cadence/management/lead/${lead_id}`);
      dispatch(slice.actions.endLoading());
      // dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadthrottle/getAllEndpoints', data);
      dispatch(slice.actions.getLeadData(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFieldMappings(clientIntegrationId=null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/mappings/fieldmappings/'+clientIntegrationId);
      dispatch(slice.actions.getFieldMappings(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFieldMappingsAll(clientIntegrationId=null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/mappings/fieldmappings_all/'+clientIntegrationId);
      dispatch(slice.actions.getFieldMappingsAll(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getClientPhoneFieldMappings(endpointId=null) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/mappings/client_phone_fieldmappings/'+endpointId);
      dispatch(slice.actions.getClientPhoneFieldMappings(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInboundProducts(clientIntegrationId=null, loadingIndicator = false) {
  return async (dispatch) => {
    if (loadingIndicator) dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/client/getInboundProducts', {client_integration_id : clientIntegrationId});
      dispatch(slice.actions.getInboundProducts({data: response.data, loadingIndicator: loadingIndicator}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCustomizationLibraries(clientId=null, loadingIndicator = false) {
  return async (dispatch) => {
    if (loadingIndicator) dispatch(slice.actions.startLoading());
    try {
      const response = await axiosCustomization.post('/api/lead_post/classes', {client_id : clientId});
      dispatch(slice.actions.getCustomizationLibraries({data: response.data, loadingIndicator: loadingIndicator}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostbackCustomizationLibraries(clientId=null, loadingIndicator = false) {
  return async (dispatch) => {
    if (loadingIndicator) dispatch(slice.actions.startLoading());
    try {
      const response = await axiosCustomization.post('/api/postback/classes', {client_id : clientId});
      dispatch(slice.actions.getPostbackCustomizationLibraries({data: response.data, loadingIndicator: loadingIndicator}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function publishVersion({id, name, description}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/publish/version',{id,name, description});
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}

export function routingVersionPublish(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/publishRouterVersion', {id: id});
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}


export function routingVersionDelete(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/deleteRouterVersion',{id: id});
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}

export function routingVersionRevert(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/revertRouterVersion',{id: id});
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}

export function routingVersionTest(id, json_data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/publishRouterTest', {id, json_data});
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}

export function setAsLatestVersion(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/setAsLatestVersion',{id:id});
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return{
        state:'failed'
      }
    }
  };
}
// ----------------------------------------------------------------------

export function getSaidID(lq_client_id) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/clients/lqsaidlist/'+lq_client_id);
      dispatch(slice.actions.getSaidID(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return []
    }
  };
}

// ----------------------------------------------------------------------

export function getCadenceNames() {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/mappings/cadencenames');
      dispatch(slice.actions.getCadenceNames(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getLqClientProductList(lq_client_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/clients/lqclientproductselect/'+lq_client_id);
      dispatch(slice.actions.getLqClientProductList(Object.values(response.data)));
      return Object.values(response.data)
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return null;
    }
  };
}
// ----------------------------------------------------------------------

// TODO - finalize
export function getActiveClients() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/active_clients');
      dispatch(slice.actions.getClient(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getExceptionsByClientID(clientID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/clients/exceptions/'+clientID);
      dispatch(slice.actions.getExceptionsByClientID(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function clearExceptionsByClientId(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/clients/exceptions/clear',data);
      dispatch(slice.actions.clearExceptionsByClientId(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

// TODO - finalize
export function getInactiveClients() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/inactive_clients');
      dispatch(slice.actions.getClient(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/create_client_with_integration', data);
      dispatch(slice.actions.createClientIntegration(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}
export function formatClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientIntegration(null));
  };
}

// TODO: finalize
export function createClients(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/create_client', data);
      dispatch(slice.actions.createClient(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

// TODO: finalize
export function formatClients(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClient(null));
  };
}

// ----------------------------------------------------------------------

export function updateClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client_with_integration', data);
      dispatch(slice.actions.updateClientIntegration(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function formatUpdateClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegration(null));
  };
}

// TODO - finalize
export function updateClients(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client', data);
      dispatch(slice.actions.updateClient(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO - finalize
export function formatUpdateClients(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClient(null));
  };
}

export function formatUpdateCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateCadence(null));
  };
}

// ----------------------------------------------------------------------

export function createEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/createndpoints', data);
      dispatch(slice.actions.createClientEndpoints(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function duplicationCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/duplicate/'+data.cadence, data);
      if(response.data.status){
        dispatch(slice.actions.duplicateClientCadences(response.data));
      }
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function duplicateBlackout(blackout_id, description) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/blackout/duplicate', {
          blackout_id : blackout_id,
          description : description
      });
      if(response.data.status){
        dispatch(slice.actions.duplicateBlackout(response.data));
      } else {
        dispatch(slice.actions.endLoading());
      }
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {
        state: false, 
        message: error.message
      }
    }
  };
}

export function createTokens(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/create_client_token', data);
      dispatch(slice.actions.createClientTokens(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteTokens(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/delete_client_token', data);
      dispatch(slice.actions.deleteClientTokens(response.data));
      
      
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      
      
      return false;
    }
  };
}

export function createIntegrationsEx(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if (!data.is_active)  {
        data.is_active = 0;
      }
      const response = await axios.post('/iapi/create_client_integration', data);
      dispatch(slice.actions.createClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteIntegrationsEx(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/delete_client_integration', data);
      dispatch(slice.actions.deleteClientIntegrationsEx(response.data));
      
      
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      
      
      return false;
    }
  };
}

export function createPhoneConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(!data.id){
        const response = await axios.post('/iapi/cadence/admin/config/phone/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.createdPhoneConfiguration(response.data));
        }
        return response.data;
      }else{
        const response = await axios.put('/iapi/cadence/admin/config/phone/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.updatedPhoneConfiguration(response.data));
        }
        return response.data;
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createSMSConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(!data.id){
        const response = await axios.post('/iapi/cadence/admin/config/sms/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.createdSMSConfiguration(response.data));
        }
        return response.data;
      }else{
        const response = await axios.put('/iapi/cadence/admin/config/sms/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.updatedSMSConfiguration(response.data));
        }
        return response.data;
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createEmailConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(!data.id){
        const response = await axios.post('/iapi/cadence/admin/config/email/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.createdEmailConfiguration(response.data));
        }
        return response.data;
      }else{
        const response = await axios.put('/iapi/cadence/admin/config/email/'+data.cadence_id+'/'+data.client_integration_id, data);
        if(response.data.status){
          dispatch(slice.actions.updatedEmailConfiguration(response.data));
        }
        return response.data;
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/delete/'+data.client_integration_id, {cadence_id:data.id});
      dispatch(slice.actions.deleteClientCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteBlackout(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/blackout/delete', {
          blackout_id : data.id,
      });
      dispatch(slice.actions.deleteBlackout(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {
        state: false, 
        message: error.message
      }
    }
  };
}

export function deleteTeam(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete('/iapi/admin/teams/' + data.id);
      // dispatch(slice.actions.deleteClientCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}


export function archiveCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/archive/', {cadence: data.id});
      dispatch(slice.actions.ArchiveClientCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createTouchPoint(cadence_id, client_id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put('/iapi/cadence/admin/config/touchpoints/'+cadence_id+'/'+client_id, data);
      dispatch(slice.actions.createClientTouchPoint(response));
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createPhoneTestLead(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/phone', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createSMSTestLead(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/sms', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createEmailTestLead(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/email', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createFolloup(cadence_id, client_id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if(data.follow_up_cadence.id) {
        const response = await axios.put('/iapi/cadence/admin/config/followups/'+cadence_id+'/'+client_id, data);
        dispatch(slice.actions.updateClientFollowUp(response));
        if(response.data) {
          return {status: true, type: 'update'}
        }
      }else {
        const response = await axios.post('/iapi/cadence/admin/config/followups/'+cadence_id+'/'+client_id, data);
        dispatch(slice.actions.createClientFollowUp(response));
        if(response.data) {
          return {status: true, type: 'create'}
        }

      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteFolloup(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/config/followups/delete', {id: id});
      dispatch(slice.actions.deleteClientFollowUp(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteEndCadence(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/config/endcadence/delete', {id: id});
      dispatch(slice.actions.deleteClientEndCadence(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createEndCadence(cadence_id, client_id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
        const response = await axios.post('/iapi/cadence/admin/config/endcadence/'+cadence_id+'/'+client_id, data);
        if ( data?.id ) {
          dispatch(slice.actions.updateClientEndCadence(response));
        } else {
          dispatch(slice.actions.createClientEndCadence(response));
        }
        return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createCadence(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/create/'+data.client_integration_id, data);
      dispatch(slice.actions.createClientCadences(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createBlackout(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/blackout/create', data);
      dispatch(slice.actions.createBlackout(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {
        state: false, 
        message: error.message
      }
    }
  };
}

export function saveTeam(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/admin/teams', data);
      // dispatch(slice.actions.createClientCadences(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteAdhocJob(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/jobs/adhoc/delete', {data_redaction_adhoc_job_id: id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function createAdhocJob(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/jobs/adhoc/create', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function updateAdhocJob(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/jobs/adhoc/update', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function createDataRedaction(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/create', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function updateDataRedaction(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/update', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function deleteDataRedaction(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/delete', {data_redaction_id: id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompletedRedactionJobs(data_redaction_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/jobs/getCompletedJobs', {data_redaction_id : data_redaction_id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function getPendingAdhocJobs(data_redaction_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/jobs/adhoc/getPendingAdhocJobs', {data_redaction_id : data_redaction_id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {status: false, message: error?.message ?? "Error"}
    }
  };
}

export function getTeams() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/admin/teams');
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function getDataRedaction(data_redaction_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/dataRedaction/getDataRedaction', {data_redaction_id: data_redaction_id});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function getDataRedactions() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/dataRedaction/getDataRedactions');
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function createVersion(data) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/createversion', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatClientEndpoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientEndpoints(null));
  };
}

export function formatClientTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientTokens(null));
  };
}

export function formatDeleteClientTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.deleteClientTokens(null));
  };
}

export function formatClientIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientIntegrationsEx(null));
  };
}

export function formatDeleteClientIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.deleteClientIntegrationsEx(null));
  };
}

// ----------------------------------------------------------------------

export function getScheduledPauses(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const firstId = data.id.split(",")[0];
      const firstClientIntegrationId = data.client_integration_id.split(",")[0];
      const response = await axios.get('/iapi/cadence/admin/config/scheduledpause/' +
        firstId + "/" + firstClientIntegrationId, data);
      dispatch(slice.actions.getScheduledPauses(response.data));
      return response.data;;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateScheduledPauses(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const firstId = data.id.split(",")[0];
      const firstClientIntegrationId = data.client_integration_id.split(",")[0];
      const response = await axios.post('/iapi/cadence/admin/config/scheduledpause/' +
        firstId + "/" + firstClientIntegrationId, data);
      dispatch(slice.actions.updateScheduledPauses(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateClientEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/updatendpoints', data);
      dispatch(slice.actions.updateClientEndpoints(response.data));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function duplicateClientEndpoints(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/duplicatendpoints', data); /* TODO: Change to */
      dispatch(slice.actions.duplicateClientEndpoints(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateClientCadence(data, endCadence) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/admin/update/' + data.client_integration_id, {
        name: data.name,
        description: data.description,
        cadence_id: data.id,
        status: data.status ? parseInt(data.status) : null,
        wait_close_time: data.wait_close_time,
        end_cadence: endCadence
      });
      dispatch(slice.actions.updateClientCadences(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateBlackout(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/blackout/update', data);
      dispatch(slice.actions.updateBlackout(response));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {
        state: false, 
        message: error.message
      }
    }
  };
}

export function formatUpdateEndpoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientEndpoints(null));
  };
}

export function formatDuplicateEndpoints() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.duplicateClientEndpoints(null));
  };
}

export function startCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/start', data);
      dispatch(slice.actions.startCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function pauseCadences(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/pause', data);
      dispatch(slice.actions.pauseCadences(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function updateClientTokens(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client_token', data);
      dispatch(slice.actions.updateClientTokens(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatUpdateTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientTokens(null));
  };
}

export function updateClientIntegrationsEx(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client_integration', data);
      dispatch(slice.actions.updateClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatUpdateIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegrationsEx(null));
  };
}


// ----------------------------------------------------------------------

export function getDetailInfo(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getdetail', {id: id});
      dispatch(slice.actions.getDetailInfo(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCallCadenceList(id) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadences/show/'+id);
      dispatch(slice.actions.getCadenceNames(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getLqCadencesList(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/clients/cadences/'+id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getPhoneConfigData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/phone/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getCadenceInfo(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/all/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getBookingList(client_integration_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getBookingList', {client_integration_id});
      dispatch(slice.actions.getBookingList(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function viweSMSLog(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/logs/sms', {cadence_id: cadence_id});
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function viwePhoneLog(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/logs/phone', {cadence_id: cadence_id});
      return (response.data)
    } catch (error) {
      return []
    }
  };
}

export function viweEmailLog(cadence_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/logs/email', {cadence_id: cadence_id});
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getSMSConfigData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadence/admin/config/sms/'+cadence_id+'/'+client_integration_id);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      return []
    }
  };
}

export function getEndCadenceType() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/getEndCadenceType');
      dispatch(slice.actions.getEndCadenceType(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getTouchPointData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadence/admin/config/touchpoints/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getEmailConfigData(cadence_id, client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/config/email/'+cadence_id+'/'+client_integration_id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function clientSearch(keyword) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/search_client?keyword='+keyword);
      return response.data
    } catch (error) {
      return []
    }
  };
}


export function setCallCadenceList(id,data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadences/update/'+id, {cadences:JSON.stringify(data)});
      dispatch(slice.actions.getCadenceNames(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}
export function formatDetailInfo() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.getDetailInfo(null));
    dispatch(slice.actions.getClientEndpoints(null));
    dispatch(slice.actions.getClientTokens(null));
    dispatch(slice.actions.getClientIntegrationsEx(null));
  };
}

// ----------------------------------------------------------------------
export function getClientEndpoints(id) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/iapi/getendpoints?id=${id}&is_version=0`);
      dispatch(slice.actions.getClientEndpoints(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSubAccount(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/iapi/get_client_integrations?client_id=${id}`);
      dispatch(slice.actions.getSubAccount(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
export function getEndpointsList(id, is_version=0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getEndpointsList', {id: id, is_version});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

// Blackout stuff
export function getBlackouts(client_integration_id, show_past = false) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/blackout/getBlackouts', {
          "client_integration_id" : client_integration_id,
          "show_past" : show_past
      });
      let data  = response.data;
      dispatch(slice.actions.endLoading());
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false;
    }
  };
}

// Cadence stuff:

export function getClientCadences(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadence/admin/list/'+ id);
      let data  = response.data;
      dispatch(slice.actions.endLoading());
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadLists(cadence_id, filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/leads', {
          "cadence_id" : cadence_id,
          "filters" : filter
      });
      dispatch(slice.actions.endLoading());
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPendingLeadLists(endpoint_id, filter) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/pendingLeads', {
          "endpoint_id" : endpoint_id,
          "filters" : filter
      });
      let data  = response.data;
      dispatch(slice.actions.endLoading());
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
};

export function previousTouchpoints(lead_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadence/management/previoustouchpoints', {
          "lead_id" : lead_id,
      });
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getActiveCadences(client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEndCadence(client_integration_id, cadence_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/endcadence/'+cadence_id+'/'+client_integration_id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadDetail(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/lead', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function pullLead(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/pull_lead', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function multi_pull_lead(ids) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/multi_pull_lead', {lead_ids: ids});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function moveToCadence(lead_id, cadence_id, old_cadence) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/move_to_cadence', {lead_id: lead_id, cadence_id: cadence_id, old_cadence: old_cadence});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTouchpoints(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/touchpoints', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCadenceStatus(id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/cadence_status', {lead_id: id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getTouchpointsInbound(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/management/touchpoints_inbound', {lead_id: id});
      let data  = response['data']
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPastCadence(cadence_id, lead_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.post('/iapi/cadence/management/previous_cadence_summary', {cadence_id: cadence_id, lead_id: lead_id});
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function pauseUnpauseEndpoint(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/pauseUnpauseEndpoint', data);
      let res  = response.data
      return res;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function sendEmailTest(postData) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/emailmessage', postData);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function sendSMSTest(postData) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/cadence/admin/validate/smsmessage', postData);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowUp(client_integration_id, cadence_id) {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/followups/'+cadence_id+'/'+client_integration_id);
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowUpTypes() {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/getfollowuprules');
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFollowUpTargets() {
  return async (dispatch) => {
    try {
      // const response = await axios.get('/iapi/cadence/admin/list/'+ client_integration_id +'?status=1');
      const response = await axios.get('/iapi/cadence/admin/config/getfollowuptargets');
      dispatch(slice.actions.endLoading());
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function getClientTokens(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {      
      const response = await axios.post('/iapi/get_client_tokens', {id: id});
      dispatch(slice.actions.getClientTokens(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTokenById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/get_token_by_id', {id: id});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getClientIntegrationsEx(id, silent = false) {
  return async (dispatch) => {
    if (!silent) dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/get_client_integrations', {client_id: id});
      dispatch(slice.actions.getClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getClientIntegrationsBasic(id, silent = false) {
  return async (dispatch) => {
    if (!silent) dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/get_client_integrations_basic', {client_id: id});
      dispatch(slice.actions.getClientIntegrationsBasic(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getClientIntegrationsNoRedaction(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/getClientIntegrationsNoRedaction', {client_id: id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getClientsNoRedaction() {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/dataRedaction/getClientsNoRedaction');
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getClientIntegrationEx(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/get_client_integration', {id: id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEndPointMapping(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      
      
      const response = await axios.get(`/iapi/getendpoints?id=${id}&is_version=0`);
      dispatch(slice.actions.getEndPointMapping(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getEndpointById(id, is_version=0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/client/endpoint/getEndpointById', {id: id, is_version});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVersionById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getVersionById', {id: id});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setRouterConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/setRouterConfiguration', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getThrottleSchedule(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/iapi/leadthrottle/getThrottleSchedule/${id}`);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setThrottleSchedule(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadthrottle/setThrottleSchedule', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateLeadThrottleStatus(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/leadthrottle/updateLeadThrottleStatus', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getThrottleScheduleForSubaccount(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/iapi/leadthrottle/getThrottleScheduleForSubaccount/${id}`);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setThrottleScheduleForSubaccount(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadthrottle/setThrottleScheduleForSubaccount', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateLeadThrottleStatusForSubaccount(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/leadthrottle/updateLeadThrottleStatusForSubaccount', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadThrottleForSubaccount(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/leadthrottle/getLeadThrottleForSubaccount', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadRouter(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/getLeadRouter', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEventsApi(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getEventsApi', {client_integration_id: id});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInboundTypes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/eventsApi/getInboundTypes');
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getConfigureEvents(inboundId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getConfigureEvents', {api_inbound_id: inboundId});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function removeError() {
  return async (dispatch) => {
    dispatch(slice.actions.formatError());
  };
}

export function deleteConfigureEvents(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/deleteConfigureEvents', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function saveConfigureEvents(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/saveConfigureEvents', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function setEventStatusData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/setEventsApiStatus', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function setSaveEventsApi(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/setSaveEventsApi', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getRouterVersions(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/getRouterVersions', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setRouterStatus(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/setRouterStatus', data);
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPublishedVersions(id, is_version=0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getPublishedVersions', {id: id, is_version});
      dispatch(slice.actions.endLoading());
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateCadenceStatus(status, cadence_id, client_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let  response;
      if(status == 1) {
        response = await axios.post('/iapi/cadence/admin/activate', {cadence: cadence_id});
      }else if(status == 3) {
        response = await axios.post('/iapi/cadence/admin/delete/'+client_id, {cadence_id: cadence_id});
      }else if(status == 0) {
        response = await axios.post('/iapi/cadence/admin/archive', {cadence: cadence_id});
      }
      dispatch(slice.actions.endLoading());
      return response
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function retryPostbacks(clientIntegrationId, leadIds, isInbound) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/postback/retry_postbacks', {
        client_integration_id: clientIntegrationId, 
        lead_ids: leadIds,
        is_inbound: isInbound,
      });
      dispatch(slice.actions.endLoading());
      let data  = response.data
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {
        status: false,
        message: error?.message
      }      
    }
  };
}

export function retryPostbackResults(leadIds, isInbound) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/postback/retry_postback_results', {
        lead_ids: leadIds,
        is_inbound: isInbound,
      });
      // dispatch(slice.actions.endLoading());
      let data  = response.data;
      return data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return {
        status: false,
        message: error?.message
      }
    }
  };
}

export function startLoading() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
  };
}

export function endLoading() {
  return async (dispatch) => {
    dispatch(slice.actions.endLoading());
  };
}